<div id="panel-left" class="d-block border-r is-open" data-toggler="is-open" style="z-index: 11;transition: none;" appFoundation>
  <div class="hds-panel bg-white auto-height-panel pos-relative" style="overflow: visible;">

    <ng-container *ngIf="!isCollapse; else collapse">
      <div class="hds-panel-header d-block text-right padding-reset border-reset"
           style="position: relative;margin-bottom: 12px;">
        <div class="d-block hide-on-close">
          <a class="button light-gray large"
             data-toggle="panel-left"
             (click)="toggleMenu()">
            <span class="far fa-angle-left fa-lg margin-h-xs padding-h-xs"></span>
          </a>
          <div class="padding-all" style="padding-top: 5px">
            <div class="logo-image"
                 [style.background-image]="'url('+ getAccountLogoUrl()+')'">
            </div>
            <div class="d-block portal-menu-client" style="z-index: 100001">
              <h2 class="padding-b-xs" appEllipsisWithTooltip [removeWrap]="false">
                {{account?.name | firstWordsLetterToUppercase}}
              </h2>
              <h4 appEllipsisWithTooltip><em>{{userName}}</em></h4>
            </div>
          </div>
        </div>
        <div *ngIf="isConsultant" class="hide-on-close">
          <app-home-menu-switch-account (switchAccount)="onSwitchAccount()">
          </app-home-menu-switch-account>
        </div>
      </div>
    </ng-container>


    <ng-template #collapse>
      <div class="hds-panel-header d-block text-right padding-reset border-reset"
           style="margin-bottom: 12px; height: 80px">
        <div class="show-on-close">
          <a class="button light-gray large"
             data-toggle="panel-left"
             (click)="toggleMenu()">
            <span class="far fa-angle-right fa-lg margin-h-xs padding-h-xs"></span>
          </a>
        </div>
        <div class="show-on-close" style="padding: 5px;">
          <div class="d-block logo-image small"
               [style.background-image]="'url('+ getAccountLogoUrl() +')'">
          </div>
        </div>
      </div>
    </ng-template>


    <div class="hds-panel-body padding-reset">
      <div #applicationsList id="applications-list" class="hds-list insito portal-menu-list" appAutoHeightElement
           [marginOffSet]="applicationsListMarginOffSet"
           style="overflow-y: scroll">

        <a class="hds-list-item is-active margin-reset">
          <div class="grid-x">
            <div class="cell shrink">
              <div class="d-block text-center" style="width: 30px;">
                <em class="opt opt-dashboard"></em>
              </div>
            </div>
            <div class="cell auto padding-l-s">
              <h4 class="hide-on-close">{{'dashboard.title' | translate}}</h4>
            </div>
          </div>
        </a>

        <a *ngFor="let application of applications" class="hds-list-item margin-reset" href="{{application.url}}" id="{{application.appId}}" (click)="onClickRedirection(application)">
          <div class="grid-x">
            <div class="cell shrink">
              <div class="d-block text-center" style="width: 30px;">
                <em class="opt {{getIconClass(application)}} {{application.state.toLowerCase()}}"></em>
              </div>
            </div>
            <div class="cell auto padding-l-s">
              <h4 class="hide-on-close">
                <span [class]="application.state.toLowerCase()">{{application.name | applicationName}}</span>
              </h4>
            </div>
          </div>
        </a>

        <ng-container *ngIf="applicationsToDiscover.length > 0">
          <div class="hide-on-close to-discover c-finact font-bold">
            {{'menu.to-discover' | translate}}
          </div>

          <div class="show-on-close to-discover c-finact f-18">
            <span class="fa fa-compass"></span>
          </div>

          <a *ngFor="let application of applicationsToDiscover" class="hds-list-item" href="{{application.url}}" id="{{application.appId}}" (click)="onClickRedirection(application)">
            <div class="grid-x">
              <div class="cell shrink">
                <div class="d-block text-center" style="width: 30px;">
                  <em class="opt {{getIconClass(application)}} {{application.state.toLowerCase()}}"></em>
                </div>
              </div>
              <div class="cell auto padding-l-s">
                <h4 class="hide-on-close">
                  <span [class]="application.state.toLowerCase()">{{application.name | applicationName}}</span>
                </h4>
              </div>
            </div>
          </a>
        </ng-container>

      </div>
      <div *ngIf="applicationsListDisplayArrow"
           style="height: 20px;width: 100%;cursor: pointer" class="center bg-light-gray"
           (click)="scrollApplicationsListToBottom()">
        <span class="fas fa-chevron-down f-14"></span>
      </div>
    </div>

  </div>
</div>
<div id="panel-disable" class="bg-medium-gray-opacity-50 panel-disable is-hidden" data-toggler="is-hidden" appFoundation></div>
